import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import SettingsTab from "components/__new/settings/tab";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import SearchBox from "components/__new/common/SearchBox";
import Filter, { ActiveFilter } from "components/__new/common/Filter";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import Print from "components/__new/common/Print";
import Table from "components/__new/common/Table";
import Pagination from "components/__new/common/pagination";
import SlideToggle from "components/__new/common/form/SlideToggle";
import { ReactComponent as IconPlus } from "assets/images/icons/project-icons/Plus.svg";
import { ReactComponent as IconEdit } from "assets/images/icons/project-icons/edit-pencil-line.svg";
import { ReactComponent as IconInformationOutline } from "assets/images/icons/project-icons/information-outline.svg";
import DialogBox from "utils/dialogBox";
import FormDrawer from "components/__new/common/form-drawer";
import { Input } from "components/__new/common/form";
import ReactToolTip from "react-tooltip";


const List = () => {
    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();


    const [isOpenViewApproval, setIsOpenViewApproval] = useState(false);


    const deleteWorkflow = async (name) => {
        const result = await DialogBox({
			title: "Delete "+name+" 😨",
			content: "Are you sure you want to delete this approval workflow? ",
            buttonYesClass: "btn-ep-red",
			buttonYes: "Delete ",
			buttonNo: "Cancel",
		});
		if (result) {
            
        }
    }


    const toggleWorkflowStatus = async (e) => {
        const result = await DialogBox({
			title: "Activate Workflow 😊",
			content: "Are you sure you want to activate this approval workflow?",
			buttonYes: "Activate",
			buttonNo: "Cancel",
		});
		if (result) {
            
        }
    }


    return ( 
        <div>


            <DynamicHeadTag
                headerText="Approvals | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />


            <ViewApproval
                isOpen={isOpenViewApproval}
                setIsOpen={setIsOpenViewApproval}
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 border-b">
                <SettingsTab />
            </div>


            <div className="mt-6 lg:flex items-center">
                <div className="w-full lg:w-1/2">
                    <div className="flex items-center font-medium text-lg">
                        Approval workflows
                        <IconInformationOutline
                            className="w-4 ml-2"
                            data-tip
                            data-for="approval-workflows"
                        />
                        <ReactToolTip id="approval-workflows" className="tooptip-size max-w-[250px]">
                            Approval workflows allow you to create step-by-step approval processes within Earnipay.
                        </ReactToolTip>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3">
                    <Link to="/approvals" className="btn btn-md font-medium text-ep-primary hover:bg-gray-200">
                        Go to needs Approval
                    </Link>
                    <Link to="/settings/approvals/create" className="btn btn-md btn-ep-primary">
                        <IconPlus className="mr-2" />
                        Create New Workflow
                    </Link>
                </div>
            </div>

            
            <div className="mt-6 box">


                <div className="flex flex-wrap justify-between">
                    <div className="max-w-sm flex-grow sm:mr-6">
                        <SearchBox placeholder="Search for Workflow" name="search" extraUrlParams="page=1" />
                    </div>
                    <div className="flex flex-wrap space-x-3 sm:space-x-6">
                        <div>
                            <Filter filters={[]}/>
                        </div>

                        <div>
                            <DownloadAsCSV
                                ref={downloadAsCSVRef}
                                tooltip="Download approval workflows"
                                filename="Approval workflows.csv"
                                columns={[
                                    { label: "Date", key: "createdAt" },
                                    { label: "User Id", key: "user" },
                                    { label: "User Type", key: "type" },
                                    { label: "Name", key: "name" },
                                    { label: "Email Address", key: "email" },
                                    { label: "Business Id", key: "employer" },
                                    { label: "Action", key: "action" },
                                    { label: "Description", key: "description" },
                                    { label: "Request Method", key: "method" },
                                    { label: "URL Path", key: "path" },
                                    { label: "IP Address", key: "ip" },
                                ]}
                                // click={() => {
                                //     dispatch(auditTrailAction.downloadGetAuditTrail({...listParams, page: 1, limit: 2000})).then(() => {
                                //         downloadAsCSVRef.current?.downloadData();
                                //     });
                                // }}
                                // loading={auditTrailDownloadLoading}
                                // response={auditTrailDownload?.data?.docs}
                            />
                        </div>

                        <div>
                            <Print component={printComponentRef} />
                        </div>
                    </div>
                </div>

                
                <div>
                    <ActiveFilter filters={{"Start Date": "startDate", "End Date": "endDate"}} />
                </div>


                <div className="mt-6">
                    <div ref={printComponentRef}>
                        
                        <div className="mb-4 text-xl hidden print:block">
                            Approval workflows
                        </div>

                        <Table>
                            <Table.Head>
                                <th>Workflow Title</th>
                                <th>Date created</th>
                                <th>Request type</th>
                                <th>Stages</th>
                                <th></th>
                                <th>Enabled</th>
                            </Table.Head>
                            <Table.Body>

                                {[...Array(4).keys()].map((index) =>
                                    <tr key={index}>
                                        <td>
                                            <div className="font-medium">
                                                New Payroll workflow
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-[#0D0C2B]">
                                                Jun 28, 2023
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-[#667085]">
                                                Request type
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-ep-primary-700">
                                                2
                                            </div>
                                        </td>
                                        <td>
                                            <div className="flex space-x-4">
                                                <button type="button" onClick={() => setIsOpenViewApproval(true)} className="text-ep-primary font-medium hover:underline">
                                                    View
                                                </button>
                                                <Link to="/settings/approvals/12345/edit" className="text-ep-primary font-medium hover:underline">
                                                    Edit
                                                </Link>
                                                <button type="button" onClick={() => deleteWorkflow("New Payroll workflow")} className="text-[#EF4444] font-medium hover:underline">
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="flex items-center">
                                                <div className="mr-2">
                                                    {/* 
                                                    <div className="mr-2 text-ep-primary-600">
                                                        Active
                                                    </div>
                                                     */}
                                                    <div className="mr-2 text-[#9CA3AF]">
                                                        Inactive
                                                    </div>
                                                </div>
                                                <SlideToggle
                                                    active={false}
                                                    onChange={(e) => toggleWorkflowStatus(e)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                )}

                            </Table.Body>
                        </Table>

                        {/* <Maybe condition={auditTrailLoading === false && auditTrail?.data?.docs?.length > 0}> */}
                            <div className="mt-6">
                                <Pagination />
                            </div>
                        {/* </Maybe> */}

                    </div>
                </div>
            </div>

        </div>
    )
}


const ViewApproval = (props) => {
    const {isOpen, setIsOpen} = props;
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-12">
                <div className="text-lg font-bold">
                    New Payroll workflow 
                </div>

                <div className="mt-6">

                    <div>
                        <div className="text-sm text-ep-primary">
                            Payroll Type
                        </div>
                        <div className="mt-2">
                            <Input type="text" label="" value="Workflows and Approvals" disabled={true} inputClass="!text-black !font-medium" />
                        </div>
                    </div>

                    <hr className="mt-2 mb-3 !border-gray-200" />

                    <div>
                        <div className="text-sm text-[#718096]">
                            Initiator(s)
                        </div>
                        <div className="mt-2">
                            <textarea
                                style={{resize: "none", color: "#f00 !important"}}
                                label=""
                                rows="2"
                                disabled
                                value="Oladele Soyemi"
                                className="form-input-textarea !text-base !text-ep-primary !font-medium"
                            />
                        </div>
                    </div>

                    <hr className="mt-2 mb-3 !border-gray-200" />

                    <div>
                        <div className="text-sm text-[#718096]">
                            Approvers (View Request)
                        </div>
                        <div className="mt-2">
                            <textarea
                                style={{resize: "none", color: "#f00 !important"}}
                                label=""
                                rows="2"
                                disabled
                                value="Oladele Soyemi"
                                className="form-input-textarea !text-base !text-ep-primary !font-medium"
                            />
                        </div>
                    </div>

                    <hr className="mt-2 mb-3 !border-gray-200" />

                    <div>
                        <div className="text-sm text-[#718096]">
                            Approver (Final)
                        </div>
                        <div className="mt-2">
                            <textarea
                                style={{resize: "none", color: "#f00 !important"}}
                                label=""
                                rows="2"
                                disabled
                                value="Oladele Soyemi"
                                className="form-input-textarea !text-base !text-ep-primary !font-medium"
                            />
                        </div>
                    </div>

                </div>

                <div className="mt-10 flex space-x-4">
                    <Link to="/settings/approvals/12345/edit" className="btn btn-ep-primary">
                        <IconEdit className="mr-2" />
                        Edit
                    </Link>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                        Close
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}


export default List;